// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import { UserMinified, UserMinifiedFromJSON, UserMinifiedToJSON } from "./";

/**
 *
 * @export
 * @interface QacConversationThread
 */
export interface QacConversationThread {
  /**
   *
   * @type {number}
   * @memberof QacConversationThread
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof QacConversationThread
   */
  project?: number;
  /**
   *
   * @type {number}
   * @memberof QacConversationThread
   */
  company: number;
  /**
   *
   * @type {UserMinified}
   * @memberof QacConversationThread
   */
  createdBy?: UserMinified;
  /**
   *
   * @type {string}
   * @memberof QacConversationThread
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof QacConversationThread
   */
  status: QacConversationThreadStatusEnum;
  /**
   * Origin URL where the conversation was started
   * @type {string}
   * @memberof QacConversationThread
   */
  sourceUrl: string;
  /**
   * Flexible JSON for linking related entities (e.g., test_case, run, requirement, suite)
   * @type {{ [key: string]: any; }}
   * @memberof QacConversationThread
   */
  contextRefs?: { [key: string]: any };
  /**
   *
   * @type {number}
   * @memberof QacConversationThread
   */
  messagesCount: number;
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof QacConversationThread
   */
  lastMessageAt?: string;
  /**
   *
   * @type {string}
   * @memberof QacConversationThread
   */
  lastMessagePreview?: string;
  /**
   *
   * @type {boolean}
   * @memberof QacConversationThread
   */
  pinned?: boolean;
  /**
   * Optional metadata such as browser, environment or locale
   * @type {{ [key: string]: any; }}
   * @memberof QacConversationThread
   */
  metadata?: { [key: string]: any };
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof QacConversationThread
   */
  createdAt: string;
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof QacConversationThread
   */
  updatedAt?: string;
}

export function QacConversationThreadFromJSON(
  json: any
): QacConversationThread {
  return {
    id: json["id"],
    project: !exists(json, "project") ? undefined : json["project"],
    company: json["company"],
    createdBy: !exists(json, "created_by")
      ? undefined
      : UserMinifiedFromJSON(json["created_by"]),
    title: !exists(json, "title") ? undefined : json["title"],
    status: json["status"],
    sourceUrl: json["source_url"],
    contextRefs: !exists(json, "context_refs")
      ? undefined
      : json["context_refs"],
    messagesCount: json["messages_count"],
    lastMessageAt: !exists(json, "last_message_at")
      ? undefined
      : json["last_message_at"],
    lastMessagePreview: !exists(json, "last_message_preview")
      ? undefined
      : json["last_message_preview"],
    pinned: !exists(json, "pinned") ? undefined : json["pinned"],
    metadata: !exists(json, "metadata") ? undefined : json["metadata"],
    createdAt: json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
  };
}

export function QacConversationThreadToJSON(
  value?: QacConversationThread
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    project: value.project,
    company: value.company,
    created_by: UserMinifiedToJSON(value.createdBy),
    title: value.title,
    status: value.status,
    source_url: value.sourceUrl,
    context_refs: value.contextRefs,
    messages_count: value.messagesCount,
    last_message_at: value.lastMessageAt,
    last_message_preview: value.lastMessagePreview,
    pinned: value.pinned,
    metadata: value.metadata,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum QacConversationThreadStatusEnum {
  Open = "open",
  Closed = "closed",
  Archived = "archived",
}
